import React from 'react';
import { motion } from 'framer-motion';
import { DropletIcon } from 'lucide-react';
import { SOAP_FAMILIES } from './salesData';
import { VARIETY_PHOTOS } from '../data/photos';
export function VarietySection() {
  return <section id="variedad" className="bg-sand py-11 sm:py-14" data-id="element-273" data-mp="33cw2nmg8he92">
      <div className="mx-auto max-w-md px-5 sm:max-w-3xl" data-id="element-274" data-mp="38cih1z7st0jg">
        <div className="text-center" data-id="element-275" data-mp="38axo2e14tpnp">
          <h2 className="mx-auto max-w-[22ch] font-display text-[1.4rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:text-[2rem]" data-id="element-276" data-mp="2ulnet5rt1hou">
            Qué podés fabricar
          </h2>
          <p className="mx-auto mt-2.5 max-w-[38ch] font-sans text-[0.86rem] leading-relaxed text-taupe" data-id="element-277" data-mp="2kng06tkznbq0">
            10 familias de jabones, de tu primer jabón a líneas que parecen de boutique.
          </p>
        </div>

        <ul className="mt-5 grid grid-cols-2 gap-1.5 sm:grid-cols-4" data-id="element-278" data-mp="2bm9hqeys3qu4">
          {VARIETY_PHOTOS.map(photo => <li key={photo.src} data-id="element-279" data-mp="2fmtf9jn9kwgs">
              <img src={photo.src} alt={photo.alt} loading="lazy" decoding="async" className="aspect-square w-full rounded-xl object-cover" data-id="element-280" data-mp="2fq7jyyjehhre" />
            </li>)}
        </ul>

        <motion.ul initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-2 grid gap-1.5 sm:grid-cols-2" data-id="element-281" data-mp="1bz4la0wehhhe">
          {SOAP_FAMILIES.map(family => <li key={family} className="flex items-center gap-2.5 rounded-xl bg-white px-3 py-2.5 font-display text-[0.82rem] font-semibold leading-tight text-charcoal" data-id="element-282" data-mp="t0s9s8i0nvin">
              <DropletIcon className="h-3.5 w-3.5 shrink-0 text-gold" aria-hidden strokeWidth={2.5} data-id="element-283" data-mp="k7q099mhw1l" />
              {family}
            </li>)}
        </motion.ul>
      </div>
    </section>;
}